// @ts-ignore
import { IModelConstructor } from '../interfaces/IModelConstructor';
import { action, computed, makeObservable, observable } from 'mobx';
import { ListLikeVM } from './ListLikeVM';
import { withPagination } from '../traits/withPagination';
import { withQuerySchema } from '../traits/withQuerySchema';
import { makeMetadata, property, handler } from '../helpers/decorators';
import { SimpleRecord } from '../interfaces/types';

export class TableLikeVM extends withQuerySchema(withPagination(ListLikeVM)) {
  constructor(...args: any[]) {
    super(...args);
    makeObservable(this);
    makeMetadata(this);
  }

  /**
   * 当前VM的columns信息
   * @example
   *
   */
  @property
  @observable.shallow
  columns: any[] = [];

  @property
  @observable
  selectedValue: any[] = [];

  @action
  setSelectedValue(selected: any[]) {
    this.selectedValue = selected;
    return this;
  }

  @action
  setColumns(columns: any[]): this {
    this.columns = columns;
    return this;
  }

  @property
  @computed
  get dataSource() {
    return { list: this.data ?? [], total: this.total ?? 0 };
  }

  set dataSource(dataSource: any) {
    this.setData(dataSource?.list);
    this.setTotal(dataSource?.total);
  }

  @handler
  @action
  onFieldGroupChange(value: any) {
    this.setState({ fieldGroup: value });
  }

  @handler
  @action
  onDataChange(data: SimpleRecord[]) {
    this.setData(data);
  }

  @handler
  @action
  onSelectChange(_: any, selected: any[]) {
    this.setSelectedValue(selected);
  }
}
